/* eslint-disable */
import useGlobal from '../hooks/useGlobal'

import { useEffect, useState, Fragment } from 'react'
import { Transition, Dialog } from '@headlessui/react'
import axios from 'axios'

const Starter = () => {
  const { progress, quote, goToStep, api, token } = useGlobal()

  const [isOpen, setIsOpen] = useState(false)
  const [hearAboutUs, setHearAboutUs] = useState('--')
  const [showOther, setShowOther] = useState(false)
  const [optionSelected, setOptionSelected] = useState(false)

  useEffect(() => {
    if (quote.marketing.hearAboutUs == 'Other') {
      setShowOther(true)
    } else {
      setShowOther(false)
    }
    if (
      quote.marketing.hearAboutUs !== '--' &&
      quote.marketing.hearAboutUs !== 'Other'
    ) {
      setOptionSelected(true)
    }
    setHearAboutUs(quote.marketing.hearAboutUs)
  }, [quote])

  const closeModal = () => {
    setIsOpen(false)
  }

  const nextStep = async (e) => {
    e.preventDefault()

    if (progress.marketing.hearAboutUs == '--') {
      setIsOpen(true)
      return
    }

    if (!progress.enquiryID || progress.enquiryID === '') {
      try {
        const response = await axios.post(api + 'enquiry', {
          token: token,
          enquiry_all: JSON.stringify(progress),
        })
        progress.enquiryID = response.data.data
      } catch (error) {
        // If enquiry creation fails, don't advance.
        setIsOpen(true)
        return
      }
    }

    goToStep(1, 'complete')
  }

  return (
    <div className="w-full flex flex-col items-center px-2 md:px-0 py-6 md:py-8">
      <h2 className="text-font-primary font-bold text-xl sm:text-2xl lg:text-3xl mb-0 md:mb-4 text-center">
        Contact Details
      </h2>

      <div className="flex flex-col justify-center max-w-3xl w-full">
        <div>
          <form className="mt-4" onSubmit={nextStep}>
            <div className="flex flex-col sm:flex-row space-y-2 sm:space-y-0 sm:space-x-4 mb-2 md:mb-4">
              <div className="input-group">
                <label htmlFor="contact_name">
                  Your Name<span className="required">*</span>
                </label>
                <input
                  type="text"
                  required
                  id="contact_name"
                  name="contact_name"
                  className="cm-input"
                  defaultValue={progress.contact_name}
                  onChange={(e) => (progress.contact_name = e.target.value)}
                />
              </div>
              <div className="input-group">
                <label htmlFor="contact_tel">
                  Your Position<span className="required">*</span>
                </label>
                <input
                  type="text"
                  required
                  id="contact_position"
                  name="contact_position"
                  className="cm-input"
                  defaultValue={progress.contact_position}
                  onChange={(e) => (progress.contact_position = e.target.value)}
                />
              </div>
            </div>
            <div className="flex flex-col sm:flex-row space-y-2 sm:space-y-0 sm:space-x-4 md-2 md:mb-4">
              <div className="input-group">
                <label htmlFor="contact_email">
                  Your Email<span className="required">*</span>
                </label>
                <input
                  type="email"
                  required
                  id="contact_email"
                  name="contact_email"
                  className="cm-input"
                  defaultValue={progress.contact_email}
                  onChange={(e) => (progress.contact_email = e.target.value)}
                />
              </div>
              <div className="input-group">
                <label htmlFor="contact_tel">
                  Your Phone Number<span className="required">*</span>
                </label>
                <input
                  type="tel"
                  required
                  id="contact_tel"
                  name="contact_tel"
                  className="cm-input"
                  defaultValue={progress.contact_tel}
                  onChange={(e) => (progress.contact_tel = e.target.value)}
                />
              </div>
            </div>
            <div className="input-group">
              <label htmlFor="hear_about_us">
                Where did you hear about us?
                <span className="required">*</span>
              </label>
              <select
                required
                id="hear_about_us"
                name="hear_about_us"
                className="cm-input"
                value={hearAboutUs}
                onChange={(e) => {
                  setHearAboutUs(e.target.value)
                  quote.marketing.hearAboutUs = e.target.value
                  progress.marketing.hearAboutUs = e.target.value
                  quote.marketing.hearAboutUsOther = ''
                  progress.marketing.hearAboutUsOther = ''
                  quote.marketing.hearAboutUsInfo = ''
                  progress.marketing.hearAboutUsInfo = ''
                  if (e.target.value == 'Other') {
                    setShowOther(true)
                  } else {
                    setShowOther(false)
                  }
                  if (e.target.value != 'Other') {
                    setOptionSelected(true)
                  } else {
                    setOptionSelected(false)
                  }
                }}
              >
                <option value="--" disabled>
                  Select an option
                </option>
                <option value="Recommendation from another school">
                  Recommendation from another school
                </option>
                <option value="Email or letter from Schools Advisory Service">
                  Email or letter from Schools Advisory Service
                </option>
                <option value="Online Search Engine">
                  Online Search Engine
                </option>
                <option value="Met at a Conference or Event">
                  Met at a Conference or Event
                </option>
                <option value="Met at a Cluster Meeting/School Forum">
                  Met at a Cluster Meeting/School Forum
                </option>
                <option value="Previously insured with SAS">
                  Previously insured with SAS
                </option>
                <option value="Had a quote from SAS in the past">
                  Had a quote from SAS in the past
                </option>
                <option value="Via another partner or association">
                  Via another partner or association
                </option>
                <option value="Other">Other</option>
              </select>
              {showOther && (
                <div className="input-group mt-2">
                  <label htmlFor="marketingOther">
                    Other<span className="required">*</span>
                  </label>
                  <input
                    type="text"
                    required
                    placeholder="Where did you hear about us?"
                    id="marketingOther"
                    name="marketingOther"
                    className="cm-input"
                    defaultValue={quote.marketing.hearAboutUsOther}
                    onChange={(e) => {
                      quote.marketing.hearAboutUsOther = e.target.value
                      progress.marketing.hearAboutUsOther = e.target.value
                    }}
                  />
                </div>
              )}
              {optionSelected && (
                <div className="input-group mt-2">
                  <label htmlFor="marketingOther">
                    More Info<span></span>
                  </label>
                  <input
                    type="text"
                    placeholder="Tell us more"
                    id="marketingInfo"
                    name="marketingInfo"
                    className="cm-input"
                    defaultValue={quote.marketing.hearAboutUsInfo}
                    onChange={(e) => {
                      quote.marketing.hearAboutUsInfo = e.target.value
                      progress.marketing.hearAboutUsInfo = e.target.value
                    }}
                  />
                </div>
              )}
            </div>

            <div className="flex justify-end items-center mt-8">
              <button className="btn w-full bg-primary hover:bg-primary-hover text-white">
                Next: Select Your School
              </button>
            </div>
          </form>
        </div>
      </div>

      <Transition appear show={isOpen} as={Fragment}>
        <Dialog as="div" className="relative z-30" onClose={closeModal}>
          <Transition.Child
            as={Fragment}
            enter="ease-out duration-300"
            enterFrom="opacity-0"
            enterTo="opacity-100"
            leave="ease-in duration-200"
            leaveFrom="opacity-100"
            leaveTo="opacity-0"
          >
            <div className="fixed inset-0 bg-black bg-opacity-25" />
          </Transition.Child>

          <div className="fixed inset-0 overflow-y-auto">
            <div className="flex min-h-full items-center justify-center p-4 text-center">
              <Transition.Child
                as={Fragment}
                enter="ease-out duration-300"
                enterFrom="opacity-0 scale-95"
                enterTo="opacity-100 scale-100"
                leave="ease-in duration-200"
                leaveFrom="opacity-100 scale-100"
                leaveTo="opacity-0 scale-95"
              >
                <Dialog.Panel className="w-full max-w-2xl transform overflow-hidden rounded-2xl bg-white p-6 py-8 text-left align-middle shadow-xl transition-all">
                  <Dialog.Title
                    as="h3"
                    className="text-3xl font-bold leading-6 text-slate-800 mb-6"
                  >
                    An Error Occured
                  </Dialog.Title>
                  <div className="mt-2 text-base">
                    Please make sure you fill in all the options in the contact
                    details section.
                  </div>

                  <div className="mt-8 flex justify-end">
                    <button
                      className="btn bg-blue-500 hover:bg-blue-600 text-white"
                      onClick={closeModal}
                    >
                      Close
                    </button>
                  </div>
                </Dialog.Panel>
              </Transition.Child>
            </div>
          </div>
        </Dialog>
      </Transition>
    </div>
  )
}

export default Starter
